import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  forwardRef,
  ViewChild,
  ElementRef,
  AfterViewInit,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';

@Component({
  selector: 'ngx-text-area-input',
  templateUrl: './text-area-input.component.html',
  styleUrls: ['./text-area-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextAreaInputComponent),
      multi: true,
    },
  ],
})
export class TextAreaInputComponent implements OnInit, ControlValueAccessor, AfterViewInit, OnChanges {
  @Input() showErrorMessage: boolean = false;
  private delayTime: number = 1000;
  private validtionDelay;
  @Input() _inputValue = undefined;
  @Input() require = false;
  @Input() label = '';
  @Input() size = 'small';
  @Input() range = [0, 1500];
  @ViewChild('child', { static: false }) feild: ElementRef;
  @Output() inputValid = new EventEmitter<boolean>();
  @Input() readonly: boolean = false;
  constructor() {}
  get inputValue() {
    return this._inputValue;
  }

  set inputValue(val) {
    this._inputValue = val;
    this.propagateChange(this._inputValue);
  }
  propagateChange = (_: any) => {};

  registerOnChange(fn) {
    this.propagateChange = fn;
  }
  registerOnTouched() {}
  writeValue(value: any) {
    if (value !== undefined) {
      this.inputValue = value;
    }
  }

  startCountingToShowValidation(feild: NgModel) {
    if (!feild.control.valid) {
      this.cancelValidation();
      this.Validate();
    } else this.showErrorMessage = false;
    this.inputValid.emit(feild.control.valid);
  }

  Validate() {
    this.validtionDelay = setTimeout(() => {
      this.showErrorMessage = true;
    }, this.delayTime);
  }

  cancelValidation() {
    clearTimeout(this.validtionDelay);
  }

  ngOnInit() {}

  ngAfterViewInit(): void {
    this.emitValidity();
  }
  ngOnChanges(changes: SimpleChanges) {
    this.emitValidity();
  }
  emitValidity() {
    setTimeout(() => {
      if (this.feild && this.feild.nativeElement) this.inputValid.emit(this.feild.nativeElement.validity.valid);
    });
  }
}
